/** @jsxImportSource @emotion/react */

import useStyles from './styles';
import useStylesFilter from './stylesFilter';

const CFAContactCountyBNR = ({ isFilter = false }) => {
  const defaultStyles = useStyles();
  const filterStyles = useStylesFilter();
  const styles = isFilter ? filterStyles : defaultStyles;
  const localCountyText = isFilter ? (
    <a
      css={styles.CFACCButton}
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.englandfootball.com/participate/leagues-and-clubs/county-football-associations/contact"
    >
      your local County FA
    </a>
  ) : (
    'your local County FA'
  );
  return (
    <div css={styles.CFAContactCountyBNRCont}>
      <div css={styles.CFABannerText}>
        <h2 css={styles.CFACCTitle}>Can’t find what you’re looking for?</h2>
        <p css={styles.CFACCSubTitle}>
          Get in touch with {localCountyText} for support in finding suitable
          playing opportunities
        </p>
      </div>
      {!isFilter && (
        <a
          css={styles.CFACCButton}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.englandfootball.com/participate/leagues-and-clubs/county-football-associations/contact"
        >
          CONTACT YOUR COUNTY FA
        </a>
      )}
    </div>
  );
};

export default CFAContactCountyBNR;
